import { Flex, Typography } from '@coolblue-development/freddy';
import { getServerRequestContext } from '@coolblue-development/next-request-context/server';
import { getServerTranslation } from '@i18n/getServerTranslation';

import { type Slug, SLUGS } from './slugs';
import SortingWrapper from './SortingWrapper';

export const options: Slug[] = [
  'relevance',
  'bestReviewed',
  'priceLowToHigh',
  'priceHighToLow',
  'mostSold'
];

export const identifier = 'sort';

export default async function Sorting() {
  const { t } = await getServerTranslation('webshop.filterPage.sortSelect');
  const { language } = await getServerRequestContext();

  return (
    <Flex gap={300} alignItems='center'>
      <Typography mb={0} component='label' htmlFor={identifier}>
        {t('label')}:
      </Typography>

      <SortingWrapper id={identifier} name={identifier}>
        {options.map(option => (
          <option key={option} value={SLUGS[option][language]}>
            {t(option)}
          </option>
        ))}
      </SortingWrapper>
    </Flex>
  );
}
